import { apiClient } from './client';
import { User } from './userEndpoints';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  message: string;
}

export interface LogoutResponse {
  message: string;
}

export const authEndpoints = {
  // Login
  login: (email: string, password: string) =>
    apiClient.post<LoginResponse>('/api/auth/login', { email, password }),

  // Logout
  logout: () => apiClient.post<LogoutResponse>('/api/auth/logout'),

  // Get current session
  me: () => apiClient.get<LoginResponse>('/api/auth/me'),
};
